import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquationBuilderComponent } from './equation-builder/equation-builder.component';
import { EquationBarComponent } from './equation-bar/equation-bar.component';
import { FormsModule } from '@angular/forms';
import { AceModule } from 'ngx-ace-wrapper';
import { MaterialModule } from '@core/material.module';

@NgModule({
  imports: [CommonModule, FormsModule, AceModule, MaterialModule],
  declarations: [EquationBarComponent, EquationBuilderComponent],
  exports: [EquationBarComponent, EquationBuilderComponent],
})
export class EquationsModule {}
